document.addEventListener('DOMContentLoaded', () => {
  const productMain = document.querySelector("main[data-template^='product'], main[data-template*='product']");
  if (!productMain) return;

  const getForm = (button) => {
    const formId = button.getAttribute('data-form-id');
    if (!formId) return null;
    return document.getElementById(formId);
  };

  const getVariantPayload = (form) => {
    if (!form) return null;
    const idInput = form.querySelector("input[name='id']");
    if (!idInput || !idInput.value) return null;

    const quantityInput =
      form.querySelector("input[name='quantity']") ||
      form.querySelector("quantity-selector-component input[name='quantity']");

    const quantity = quantityInput && quantityInput.value ? parseInt(quantityInput.value, 10) : 1;

    return {
      id: idInput.value,
      quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1
    };
  };

  const addToCartAndGoToCheckout = async (payload) => {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error('cart_add_failed');
    }

    window.location.href = '/checkout';
  };

  const getExcerpt = (sourceText) => {
    const normalized = (sourceText || '').replace(/\s+/g, ' ').trim();
    if (normalized.length <= 160) return normalized;

    let excerpt = normalized.slice(0, 160);
    const lastSpace = excerpt.lastIndexOf(' ');
    if (lastSpace > 120) {
      excerpt = excerpt.slice(0, lastSpace);
    }
    return `${excerpt}…`;
  };

  const removeMobileSummary = () => {
    document.querySelectorAll('.ld-mobile-product-summary').forEach((node) => node.remove());
    document.querySelectorAll('.ld-mobile-hide').forEach((node) => node.classList.remove('ld-mobile-hide'));
  };

  const buildMobileProductSummary = () => {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    removeMobileSummary();
    if (!isMobile) return;

    document.querySelectorAll('.product-information__grid').forEach((grid) => {
      const media = grid.querySelector('.product-information__media');
      const details = grid.querySelector('.product-details');
      if (!media || !details) return;

      const title = details.querySelector('h1');
      const summarySource = details.querySelector('[data-ld-product-summary-source]');
      const excerptNode = summarySource?.querySelector('.text-block, rte-formatter, .rte');
      const actionsSource = summarySource?.querySelector('.ld-ritual-actions');
      if (!title || !summarySource || !excerptNode) return;

      let titleHideNode = title;
      while (titleHideNode.parentElement && !titleHideNode.parentElement.classList.contains('group-block-content')) {
        titleHideNode = titleHideNode.parentElement;
      }
      titleHideNode.classList.add('ld-mobile-hide');
      summarySource.classList.add('ld-mobile-hide');

      const summary = document.createElement('div');
      summary.className = 'ld-mobile-product-summary';

      const heading = document.createElement('h1');
      heading.className = 'ld-mobile-product-summary__title';
      heading.textContent = title.textContent.trim();
      summary.appendChild(heading);

      const reviewSource = details.querySelector('.review, .rating-wrapper, [data-rating], .jdgm-prev-badge');
      const reviewsTarget = document.querySelector('#LDProductReviews');
      if (reviewSource && reviewSource.textContent.trim() && reviewsTarget) {
        const reviewsButton = document.createElement('button');
        reviewsButton.type = 'button';
        reviewsButton.className = 'ld-mobile-product-summary__reviews';
        reviewsButton.setAttribute('aria-label', 'Vai alle recensioni');
        reviewsButton.innerHTML = reviewSource.innerHTML;
        reviewsButton.addEventListener('click', () => {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          reviewsTarget.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
        summary.appendChild(reviewsButton);
      }

      const excerpt = document.createElement('p');
      excerpt.className = 'ld-mobile-product-summary__excerpt';
      excerpt.textContent = getExcerpt(excerptNode.textContent);
      summary.appendChild(excerpt);

      if (actionsSource) {
        const clonedActions = actionsSource.cloneNode(true);
        clonedActions.classList.add('ld-mobile-product-summary__actions');
        summary.appendChild(clonedActions);
      }

      media.parentNode.insertBefore(summary, media);
    });
  };


  const enableMobileFullscreenMedia = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    document.querySelectorAll("main[data-template*='product'] .product-information__media .product-media-container--image").forEach((container) => {
      if (container.dataset.ldFullscreenBound === 'true') return;
      container.dataset.ldFullscreenBound = 'true';

      let startX = 0;
      let startY = 0;
      let moved = false;

      container.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') return;
        startX = event.clientX;
        startY = event.clientY;
        moved = false;
      }, { passive: true });

      container.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'mouse') return;
        if (Math.abs(event.clientX - startX) > 12 || Math.abs(event.clientY - startY) > 12) {
          moved = true;
        }
      }, { passive: true });

      container.addEventListener('click', (event) => {
        const zoomButton = container.querySelector('.product-media-container__zoom-button');
        if (!zoomButton) return;
        if (event.target.closest('.product-media-container__zoom-button')) return;
        if (moved) return;
        event.preventDefault();
        event.stopPropagation();
        requestAnimationFrame(() => zoomButton.click());
      });
    });
  };

  document.addEventListener(
    'click',
    async (event) => {
      const actionButton = event.target.closest('.ld-ritual-actions__button');
      if (!actionButton) return;

      event.preventDefault();

      const form = getForm(actionButton);
      const payload = getVariantPayload(form);
      if (!form || !payload) return;

      const action = actionButton.getAttribute('data-ritual-action');
      const nativeAddButton = form.querySelector('[data-testid="standalone-add-to-cart"], .add-to-cart-button, button[name="add"]');

      if (action === 'add' && nativeAddButton) {
        nativeAddButton.click();
        return;
      }

      if (action === 'checkout') {
        try {
          actionButton.setAttribute('aria-busy', 'true');
          await addToCartAndGoToCheckout(payload);
        } catch (error) {
          const fallbackHref = actionButton.getAttribute('href');
          window.location.href = fallbackHref || '/checkout';
        } finally {
          actionButton.removeAttribute('aria-busy');
        }
      }
    },
    { passive: false }
  );

  buildMobileProductSummary();
  enableMobileFullscreenMedia();

  window.addEventListener(
    'resize',
    () => {
      buildMobileProductSummary();
          enableMobileFullscreenMedia();
    },
    { passive: true }
  );
  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target.closest?.("main[data-template*='product']") && !event.target.querySelector?.("main[data-template*='product']")) return;
    buildMobileProductSummary();
    enableMobileFullscreenMedia();
  });

});
